import { styled } from '@core-ui/react-stitch';
import { BRProps } from './types';

const MainWrapper = styled.div(({ useBRRedesign, theme }: BRProps) => ({
  backgroundColor: useBRRedesign ? theme.color.b2 : 'inherit',
}));

export default MainWrapper;
